module.exports = __webpack_public_path__ + "static/2front-about-company-mission-2-c42d9783b6b0be1be5418ba3ec5ea1dd.png";